<template>

  <modal-form-helper :data="{...mdldata, title:'Create Company'}" :form="post">

    <template #body>
      <div ref="field_defs" class="d-none">
        <!-- start form -->
        <div ref="field_name">
          <form-input
              :required="false"
              v-model="post.name"
              :form="post"
              name="name"
              label="Name"
              :debounce="true"
              @input="searchNameDebounced"
              :debounce-settings="{url: genUrl('companies', null, 'search'), route_name: 'company_details', param: 'name', label: 'name'}
            "/>

        </div>

        <div ref="field_street_line_one">
          <label class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">
            <span class="">Address - Street 1</span>
          </label>
          <input
              :required="false"
              type="text"
              name="street_line_one"
              class="form-control form-control-sm  form-control-solid mb-lg-0"
              v-model="post.address.street_line_one"
              :form="post"
          />
          <has-error :form="post" field="address.street_line_one"></has-error>
        </div>

        <div ref="field_street_line_two">
          <label class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">
            <span class="">Street 2</span>
          </label>
          <input
              :required="false"
              type="text"
              name="street_line_two"
              class="form-control form-control-sm  form-control-solid mb-lg-0"
              v-model="post.address.street_line_two"
              :form="post"
          />
          <has-error :form="post" field="address.street_line_two"></has-error>
        </div>

        <div ref="field_city">
          <label class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">
            <span class="">City</span>
          </label>
          <input
              :required="false"
              type="text"
              name="city"
              class="form-control form-control-sm  form-control-solid mb-lg-0"
              v-model="post.address.city"
              :form="post"
          />
          <has-error :form="post" field="address.city"></has-error>
        </div>

        <div ref="field_state">
          <label class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">
            <span class="">State</span>
          </label>
          <input
              :required="false"
              type="text"
              name="state"
              class="form-control form-control-sm  form-control-solid mb-lg-0"
              v-model="post.address.state"
              :form="post"
          />
          <has-error :form="post" field="address.state"></has-error>
        </div>

        <div ref="field_postcode">
          <label class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">
            <span class="">Postcode / Zipcode</span>
          </label>
          <input
              :required="false"
              type="text"
              name="postcode"
              class="form-control form-control-sm  form-control-solid mb-lg-0"
              v-model="post.address.postcode"
              :form="post"
          />
          <has-error :form="post" field="address.postcode"></has-error>
        </div>

        <div ref="field_country">
          <form-select2
              :required="false"
              name="country"
              label="Country"
              :form="post"
              v-model="post.country"
              :options="drdata.country_codes"
              :config="{
                id: 'code',
                label: 'name',
              }"
              :classes="['form-select-solid']"
          />
        </div>

        <div ref="field_business_description">
          <label class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">
            <span class="">Business Description</span>
          </label>
          <input
              :required="false"
              type="text"
              name="business_description"
              class="form-control form-control-sm  form-control-solid mb-lg-0"
              v-model="post.business_description"
              :form="post"
          />
          <has-error :form="post" field="business_description"></has-error>
        </div>

        <div ref="field_pe_vc">
          <form-select2
              :required="false"
              name="pe_companies"
              label="PE/VC"
              :form="post"
              v-model="post.pe_companies"
              :options="pe_companies"
              :config="pe_companies_ajax_config"
              :classes="['form-select-solid']"
          />
        </div>

        <div ref="field_company_type">
          <form-select2
              :required="false"
              name="details.company_type"
              label="Company Type"
              :form="post"
              v-model="post.details.company_type"
              :options="drdata.company_types"
              :config="{
                label: 'title',
              }"
              :classes="['form-select-solid']"
          />
        </div>

        <div ref="field_sectors">
          <form-select2
              :required="false"
              name="details.sectors"
              label="Sector"
              :form="post"
              v-model="post.details.sectors"
              :options="drdata.sectors"
              :config="{
                label: 'title',
                multiple: true,
              }"
              :classes="['form-select-solid']"
          />
        </div>

        <div ref="field_sub_sectors">
          <form-select2
              :required="false"
              name="details.sub_sectors"
              label="Sub Sector"
              :form="post"
              v-model="post.details.sub_sectors"
              :options="optgroupSubsectors"
              :config="{
                multiple: true,
                preventTransform: true,
              }"
              :classes="['form-select-solid']"
          />
        </div>

        <div ref="field_source">
          <form-select2
              :required="false"
              name="details.source"
              label="Source"
              :form="post"
              v-model="post.details.source"
              :options="drdata.source"
              :config="{
                id: 'id',
                label: 'title',
                ajax: {
                  paginated: false,
                  url: genUrl('source_type', null,  'get'),
                  term: 'title',
                }
              }"
              :classes="['form-select-solid']"
          />
        </div>

        <div ref="field_ownership">
          <form-select2
              :required="false"
              name="details.ownership"
              label="Ownership"
              :form="post"
              v-model="post.details.ownership"
              :options="drdata.ownerships"
              :config="{
                label: 'name',
              }"
              :classes="['form-select-solid']"
          />
        </div>

        <div ref="field_relationship">
          <form-select2
              :required="false"
              name="details.relationship"
              label="Relationship"
              :form="post"
              v-model="post.relationship"
              :options="drdata.relationship"
              :config="{
                label: 'name',
              }"
              :classes="['form-select-solid']"
          />
        </div>

        <div ref="field_revenue">
          <label class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">
            <span class="">Revenue</span>
          </label>
          <input
              :required="false"
              type="text"
              name="revenue"
              class="form-control form-control-sm  form-control-solid mb-lg-0"
              v-model="post.revenue"
              :form="post"
          />
          <has-error :form="post" field="revenue"></has-error>
        </div>

        <div ref="field_ebitda">
          <label class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">
            <span class="">EBITDA</span>
          </label>
          <input
              :required="false"
              type="text"
              name="ebitda"
              class="form-control form-control-sm  form-control-solid mb-lg-0"
              v-model="post.ebitda"
              :form="post"
          />
          <has-error :form="post" field="ebitda"></has-error>
        </div>
        <!-- end form -->

        <!--contact-->
        <div ref="field_title">
          <form-select2
              :required="false"
              name="title"
              label="Title"
              :form="post"
              v-model="post.contact.title"
              :options="drdata.titles"
              :config="{
                          id: 'id',
                          label: 'title',
                          ajax: {
                            paginated: false,
                            url: genUrl('user_title', null,  'get'),
                            term: 'title',
                          }
                        }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_first_name">
          <form-input :required="false" @input="setRelationship"
                      v-model="post.contact.first_name" :form="post"
                      name="contact.first_name" label="First Name"/>
        </div>
        <div ref="field_last_name">
          <form-input :required="false" @input="setRelationship"
                      v-model="post.contact.last_name" :form="post"
                      name="contact.last_name" label="Last Name"/>
        </div>
        <div ref="field_direct_mobile">
          <form-input v-model="post.contact.direct_mobile" :required="false" :form="post" name="contact.direct_mobile" label="Mobile Phone"/>
        </div>
        <div ref="field_direct_phone">
          <form-input v-model="post.contact.direct_phone" :required="false" :form="post" name="contact.direct_phone" label="Office Phone"/>
        </div>
        <div ref="field_email">
          <form-input v-model="post.contact.email" :required="false" :form="post" name="contact.email" label="Email"/>
        </div>
        <div ref="field_job_title">
          <form-input v-model="post.contact.job_title" :required="false" :form="post" name="contact.job_title" label="Job title"/>
        </div>
        <div ref="field_users">
          <form-select2
              :required="false"
              name="contact.users"
              label="Relationships"
              placeholder=""
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.contact.users"
              :options="users"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: true,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>



        <!--Custom fields-->
        <div v-for="field in fields.custom_fields">
          <div :ref="`field_${field.field_key}`">
            <div v-if="field.field_type==='text'">
              <form-input :required="false" v-model="post[field.field_key]" :form="post"
                          :name="field.field_key" :label="field.title"/>
            </div>
            <div v-else-if="field.field_type==='long_text'">
              <form-input :required="false" v-model="post[field.field_key]" :form="post"
                          :name="field.field_key" :label="field.title"/>
            </div>
            <div v-else-if="field.field_type==='multiple_option'">
              <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
                {{ field.title }}
              </label>
              <select2
                  :required="false"
                  v-model="post[field.field_key]"
                  :options="field.options"
                  :config="{
                              label: 'label',
                              multiple: true,
                            }"
              />
            </div>
            <div v-else-if="field.field_type==='single_option'">
              <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
                {{ field.title }}
              </label>
              <select2
                  :required="false"
                  v-model="post[field.field_key]"
                  :options="field.options"
                  :config="{
                              label: 'label'
                            }"
              />
            </div>
            <div v-else-if="field.field_type==='date'" :id="`field_${field.field_key}`">
              <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label d-flex">
                {{ field.title }}
              </label>
              <date-picker
                          :value="post[field.field_key]"
                          @input="(val) => setDateForce(field.field_key, val)"
                         :typeable="false"
                           input-class="form-control form-control-sm form-control-solid mb-3 w-100"
                           format="DD-MM-YYYY"/>
            </div>
            <has-error :form="post" :field="field.field_key"></has-error>
          </div>
        </div>
      </div>

      <div ref="fields_rend">
        <div v-for="section in sections">
          <h4 v-show="section.title_show">{{ section.title }}</h4>
          <div class="row" v-for="(col, colIndex) in Array.from({length: section.max_rows})">
            <div class="col-md-6" v-for="(dir, dirIndex) in section.directions">
              <div v-if="section.fields[dirIndex][colIndex]"
                   :ref="`rend_field_${section.fields[dirIndex][colIndex].field}`"></div>
            </div>
          </div>
        </div>
      </div>


      <h4 class="py-2 mt-10 dm-fs-1-1-rem dm-color-5e6278">Select Preferred Logo</h4>
      <div class="row mb-4">
        <div v-for="(logor, index) in logo_results" class="col-lg-4">
          <!--begin::Card-->
          <div
              @click="selectLogo(index)"
              class="dropzone dropzone_logo card h-100 flex-center bg-light-primary p-4"
              :class="[logor.selected ? 'border-danger border border-dashed' : '']"
          >
            <div class="logo-container">
              <img v-if="logor.has" :src="logor.blob_url" alt="" width="148px">
            </div>
          </div>
          <!--end::Card-->
        </div>
      </div>

    </template>
    <template #footer>
      <button type="submit" class="btn btn-primary me-2">Save
        </button>
        <button
                @click="close"
                type="button"
                class="btn btn-light ml-1"
        >
          cancel
        </button>
        <button @click="createCompanyWithOpportunity()" type="button" class="btn btn-primary float-end">Save & Create Opportunity
        </button>
    </template>
  </modal-form-helper>
</template>

<script>
import cm from "@mxn/create"
import get_custom_fields from './get_custom_fields'
import UserSelector from "@cc/includes/UserSelector.vue";
import AddOpportunityModal from "@cc/modules/crm/AddOpportunityModal.vue";

import UKCompanyModal from "@cc/clients/companies/UKCompanyModal.vue"

export default {
  name: "CrmCreateCompanyModal",
  components: {UserSelector, AddOpportunityModal},
  mixins: [cm, get_custom_fields],
  props: {
    url_key: {
      default: 'crm_company'
    },
    //project|pitchbook|finder
    type: '',
    project: {default: null},
    asModal: {default: false},
    finder: null,
    fieldsets: [],
    company_fieldsets: [],
  },
  data() {
    return {
      form_category: 'company',
      id: null,
      isModal: true,

      searchingName: false,
      nameDuplicates: [],

      pe_companies: [],
      drdata: {
        company_type: [],
        sectors: [],
        sub_sectors: [],
        source: [],
        trading_status: [],
        ownership: [],
        relationship: [],
        corporate_status: [],
        currency: [],
        country_codes: [],
        project: null,

      },
      // fields: this.customFields,
      users: [],
      post: Form.make({
        name: '',
        ownership: null,
        relationship: this.$user.id,
        country: 'GB',
        revenue: '',
        ebitda: '',
        pe_companies: [],
        company_house_no:'',
        details: {
          company_type: '',
          sectors: [],
          sub_sectors: [],
          source: '',
        },
        business_description: '',
        address: {
          street_line_one: '',
          street_line_two: '',
          city: '',
          state: '',
          postcode: '',
        },
        contact: {
          title: null,
          first_name: '',
          last_name: '',
          direct_mobile: '',
          direct_phone: '',
          job_title: '',
          email: '',
          users: [this.$user.id],
        },
      }),
      logo_results: [{}, {}, {}],
      logo: {
        has: false,
        link: '',
        source: '',
        data: '',
        blob_url: '',
      },
    };
  },
  created() {
    this.searchNameDebounced = _.debounce(() => this.searchName(), 2 * 1000)
    // this.searchNameDebounced = _.debounce(() => this.fetchUKCompanySearch(), 2 * 1000)
  },
  computed: {
    pe_companies_ajax_config(){
      return {
        multiple: true,
        id: 'id',
        label: 'name',
        ajax: {
          paginated: false,
          url: this.genUrl('companies', null,  'search'),
          term: 'name',
          params: {pe_only: 1},
        }
      }
    },
    optgroupSubsectors() {
      if (!this.post.details.sectors) return []

      let data = []
      this.drdata.sectors.filter(sec => this.post.details.sectors.map(String).includes(String(sec.id))).forEach(sec => {
        data.push({
          id: sec.id,
          text: sec.title,
          children: this.drdata.sub_sectors.filter(sc => sec.id == sc.sector).map(sc => ({id: sc.id, text: sc.title}))
        })
      })

      return data
    },
  },
  mounted() {
    // do this before post
    // if (this.type == 'project') {
    //   this.post.update({
    //     ...this.post,
    //     project: this.project,
    //   })
    // }
    if(this.type == 'finder'){
      this.post.update({
        ...this.post,
        name: this.finder.current_employer,
        contact: {
          ...this.post.contact,
          email: this.finder.email,
          title: '',
          first_name: this.finder.first_name,
          last_name: this.finder.last_name,
          job_title: this.finder.current_title,
          direct_phone: this.finder.phone,
          experience: this.finder.job_history,
          phone_json: this.finder.phone_json,
          email_json: this.finder.email_json,
          linkedin_url:this.finder.linkedin_url,
          
        },

      })

    }

    this.fetchHelpers()

    let url = this.genUrl('crm_company', null, 'custom_fields')
    this.getCustomFields(url)

    this.users = [this.$user]
    this.$root.$on('company_number', this.handleSelectedCompanyNumberData);
  },
  destroyed() {
    this.$root.$off('company_number');
  },
  methods: {
    setRelationship(){
      if(this.post.contact.first_name || this.post.contact.last_name){
        this.post.contact.users = [this.$user.id]
      }else if(this.post.contact.first_name == '' && this.post.contact.last_name == ''){
        this.post.contact.users = []
      }
    },
    getUrl(){
      return this.genUrl('crm_company')
    },
    postRenderFields(){
      if (this.type == 'project') {
        this.post.update({
          ...this.post,
          project: this.project,
        })
      }
    },
    postCreate(res) {
      // return;
      this.$root.$emit("company_created_project", res)
      console.log(res.id)
      this.attachLogoBlob(res)
      if (!this.project) return;
      // debugger

      // axios.post(`/project${this.$route.path}/`, {
      //   items: [res.id],
      //   action: 'add_buyers'
      // }).then((response) => {
      //   console.log(response.data)
      //   this.toastSuccess("Buyer created and added to project.")
      //   this.$router.push({name: 'buyer_review', params: {id: this.$route.params.id}});
      // })
    },
    fetchHelpers() {
      axios.get(this.genUrl('companies', null, 'data'))
          .then(({data}) => {
            console.log(data)
            this.drdata = {
              ...this.drdata,
              ...data,
            }
            let default_ownership = (data.ownerships).find((el) => (el.name.toLowerCase()).trim() == "private")
            let default_company_type = (data.company_types).find((el) => (el.title.toLowerCase()).trim() == "trade")

            if(default_ownership){
              this.post.details.ownership = default_ownership.id
            }
            if(default_company_type){
              this.post.details.company_type = default_company_type.id
            }

            // this.preCreate_()
          })
          .catch(err => console.error(err))
    },
    createCompanyWithOpportunity() {
        const pr = this.preCreate()
        if(pr === false) return;
        this.startCompLoading();
        this.post[this.getMode()](this.getUrl(), {
            params: this.create_params,
            transformRequest: this.bracketTransform ? bracketTransformer : undefined,
            data: this.extraData(),
        })
        .then(({data}) => {
            this.toastSuccess();
            this.postCreate(data)
            if(!this.preventClose){
                this.$emit("close");
                this.createToOpenOpportunity(data)
            }
            this.$root.$emit(this.create_event, this.id);
        })
        .catch(err => console.error(err))
        .finally(() => this.endCompLoading());
    },
    createToOpenOpportunity(company){
      this.openOpporModal('opportunity', company)
    },
    openOpporModal(urlKey = 'opportunity', company) {
      let component_ = AddOpportunityModal

      this.$modal.show(
          component_,
          {
            urlKey,
            company:company.id,
            companies: [company],
          },
          {
            height: "auto",
            scrollable: true
          }
      );
    },
    searchName() {
      this.removeLogos()

      const name = this.post.name
      if (!name) return
      if (name.length < 3) return;
      // console.warn('ZDX')

      // this.getLogoBlob({'link': 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Apple_Computer_Logo_rainbow.svg/640px-Apple_Computer_Logo_rainbow.svg.png'})
      // return;

      this.$axios.get(this.genUrl('companies', null, 'get_company_logo'), {
        params: {name}
      }).then(({data}) => {
        if (!data.data) return

        data.data.forEach((gcd, idx) => {
          this.getLogoBlob(gcd, idx)
        })
      })
          .catch(err => {
            // this.removeLogos()
            this.toastLaraValidation(err)
          })
    },
    removeLogos(){
      this.logo_results = [{},{},{}]
    },
    selectLogo(index){
      //shuffle true/false
      this.logo_results[index].selected = !this.logo_results[index].selected
      console.warn(this.logo_results[index].selected)

      //set others to false
      this.logo_results.forEach((lg, idx) => {
        if(idx !== index){
          lg.selected = false
        }
      })
      console.warn(this.logo_results)
      this.$forceUpdate()
    },
    async getLogoBlob(cse_data, logoIndex) {

      const buildProxyUrl = (link) => {
        return `${this.genUrl('companies', null, 'company_logo_proxy')}?image_url=${link}`
      }

      const setLogoData = (logoData) => {
        this.logo_results[logoIndex].has = true
        this.logo_results[logoIndex].data = logoData
        this.logo_results[logoIndex].blob_url = URL.createObjectURL(this.logo_results[logoIndex].data);
        this.$forceUpdate()
      }

      try {
        // Fetch the image data
        const response = await axios.get(buildProxyUrl(cse_data.link), {responseType: 'blob'});
        setLogoData(response.data)

        return true
      } catch (error) {
        // this.removeLogo()
        console.error('GET_LOGO_ERROR', error);
        console.log('TRYING_FALLBACK_THUMBNAIL');

        try {
          const response = await axios.get(buildProxyUrl(cse_data.image.thumbnailLink), {responseType: 'blob'});
          setLogoData(response.data)

          return true
        } catch (error2) {
          // this.removeLogo()
          console.error('GET_LOGO_THUMB_FAILED_TOO', error);
        }
      }
    },
    async attachLogoBlob(company) {
      let logo = this.logo_results.find(lg => lg.selected)

      if (!logo?.has) {
        console.log("NO_LOGO_LINK")
        this.close()
        return
      }
      this.toastSuccess("Uploading logo..")

      try {
        // Create a FormData object and append the image Blob
        const formData = new FormData();
        formData.append('logo', logo.data, `${company.id}_${company.name}_logo_automated_csx.png`);

        const uploadResponse = await axios.put(this.genUrl('companies', company.id, 'logo'), formData);

        if (uploadResponse.status === 200) {
          this.toastSuccess("Logo uploaded!")
        } else {
          this.toastError("Failed to upload logo!")
        }
      } catch (error) {
        console.error('LOGO_UPLOAD_ERROR:', error);
      }

      this.close()
    },
    removeLogo() {
      this.logo = {
        has: false,
        link: '',
        source: '',
        data: '',
        blob_url: '',
      }
    },
    fetchUKCompanySearch(){
      let name = this.post.name
      axios.get(this.genUrl('companies', null, 'uk_company_finder'), {
        params: {name}
      }).then(({data}) => {
            console.log(data)
          this.$modal.show(UKCompanyModal, {
                records: data?.data
              }, {
                height: "auto",
                scrollable: true,
              }
          );
      })
      .catch(err => console.error(err))
    },
    handleSelectedCompanyNumberData(data) {
      console.log(data.number)
      this.post.name = data.name;
      this.post.company_house_no = data.number;
      // this.post.address = {
      //   ...data.address
      // }
    }
  },
}
</script>

<style scoped>

</style>